import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DocumentTypesState,
  DocumentType,
  DocumentTypesListData,
} from '../../types/documentTypes.types';

const initialState: DocumentTypesState = {
  documentTypes: [],
  selectedDocumentType: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const documentTypesSlice = createSlice({
  name: 'documentTypes',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setDocumentTypes: (state, action: PayloadAction<DocumentTypesListData>) => {
      state.documentTypes = action.payload.documentTypes;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedDocumentType: (state, action: PayloadAction<DocumentType | null>) => {
      state.selectedDocumentType = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedDocumentType: (state) => {
      state.selectedDocumentType = null;
    },
    addDocumentType: (state, action: PayloadAction<DocumentType>) => {
      state.documentTypes.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateDocumentType: (state, action: PayloadAction<DocumentType>) => {
      const index = state.documentTypes.findIndex((dt) => dt.id === action.payload.id);
      if (index !== -1) {
        state.documentTypes[index] = action.payload;
      }
      if (state.selectedDocumentType?.id === action.payload.id) {
        state.selectedDocumentType = action.payload;
      }
    },
    deleteDocumentType: (state, action: PayloadAction<string>) => {
      state.documentTypes = state.documentTypes.filter((dt) => dt.id !== action.payload);
      state.pagination.totalRecords -= 1;
      if (state.selectedDocumentType?.id === action.payload) {
        state.selectedDocumentType = null;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setDocumentTypes,
  setSelectedDocumentType,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedDocumentType,
  addDocumentType,
  updateDocumentType,
  deleteDocumentType,
} = documentTypesSlice.actions;

export default documentTypesSlice.reducer;
